import React from 'react';

class TestStartPageHeader extends React.Component{

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }
    handleScroll(event) {
        if(this.quizStartHeader) {
            if (window.pageYOffset === 0) {
                /*  this.quizHeader.style.transition = "top 3s ease-out"*/

                this.quizStartHeader.style.top = null;

            } else {
                /*  this.quizHeader.style.transition = "top 3s ease-out"*/
                this.quizStartHeader.style.top = "0px";

            }
        }
    }
    render(){
        return(
            <div className="quizHead" ref={input => {this.quizStartHeader = input;}}>
                <div id="QProgress">
                    <div id="QBar"> </div>
                    <div id="question-header">
                        <div id="frage-header">
                            Wichtige Hinweise
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
export default TestStartPageHeader;
